var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:#CDF6F9;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#1A83A8;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    className: "st0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_12"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_13"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_14"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_15"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_16"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_17"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_18"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_19"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_20"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_21"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_22"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_23"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_24"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_25"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 15.125,
    cy: 15.938,
    r: 12.125
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M15.097,8.983c-0.497,0-0.9,0.403-0.9,0.9V16c0,0.279,0.13,0.542,0.351,0.713l4.026,3.105   c0.164,0.126,0.357,0.188,0.549,0.188c0.27,0,0.536-0.121,0.714-0.351c0.304-0.394,0.23-0.959-0.163-1.263l-3.676-2.835V9.884   C15.997,9.387,15.594,8.983,15.097,8.983z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M29.559,12.726c-0.39-0.311-0.955-0.243-1.264,0.146l-0.467,0.589c-1.193-5.936-6.487-10.46-12.729-10.46   C7.932,3.001,2.1,8.833,2.1,16s5.832,12.999,12.999,12.999c4.812,0,9.205-2.637,11.466-6.882c0.234-0.438,0.068-0.983-0.371-1.217   c-0.438-0.234-0.984-0.066-1.217,0.371c-1.948,3.656-5.732,5.927-9.878,5.927C8.924,27.198,3.9,22.175,3.9,16   S8.924,4.802,15.099,4.802c5.329,0,9.86,3.826,10.942,8.872l-0.595-0.471c-0.39-0.312-0.955-0.243-1.264,0.146   s-0.243,0.955,0.146,1.264l2.295,1.818c0.165,0.132,0.362,0.195,0.558,0.195c0.266,0,0.528-0.117,0.706-0.342l1.818-2.295   C30.014,13.6,29.948,13.034,29.559,12.726z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.046b364d8cf7735f7cb45a8e8a568d1b.svg";
export { ForwardRef as ReactComponent };